<template>
  <div ref="boxShadowList">
    <div class="content">
      <div class="content-item" @click="clickRadioGroup">
        <cx-slider :value.sync="linkAddressVal" :options="dataOptions" :height="32" />
      </div>
      <div v-if="linkAddressVal == '内部链接'" class="content-item mt16">
        <el-select style="width: 100%" v-model="internalLinkNameVal" placeholder="请选择" @change="selectPage">
          <el-option v-for="item in internalLinks" :key="item.value" :label="item.name" :value="item"> </el-option>
        </el-select>
      </div>
      <div v-if="linkAddressVal == '下级链接'" class="content-item mt16">
        <el-select style="width: 100%" v-model="subLinkNameVal" placeholder="请选择" @change="selectSubPage">
          <el-option v-for="item in subLinks" :key="item.value" :label="item.name" :value="item"> </el-option>
        </el-select>
      </div>
      <div v-if="linkAddressVal == '自定义'" class="content-item verticallyCenter mt16">
        <el-input style="width: 100%" v-model="linkUrlVal" placeholder="请输入http://或https://开头的地址"></el-input>
      </div>
      <div  class="content-item mt16">
        <div class="content-item mb10 verticallyCenter clearFloat" v-if="isCustomLinkTo">
          <el-checkbox-group v-model="openBlankPageVal">
            <el-checkbox :label="true" class="mr16">新页面打开</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="content-item clearFloat">
          <el-checkbox-group v-model="accessRulersVal">
            <el-checkbox label="传递门户参数" v-if="linkAddressVal == '自定义'">携带系统参数</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "linkSet",
  props: {
    isYzDataCenter: {
      type: Boolean,
      default: false
    },
    openBlankPage: {
      type: [Boolean, String],
      required: true
    },
    accessRulers: {
      type: Array,
      required: true
    },
    internalLinkName: {
      type: String,
      required: true
    },
    subLinkName: {
      type: String,
      required: false
    },
    linkUrl: {
      type: String,
      required: true
    },
    linkAddress: {
      type: String
    },
    businessType: {
      type: String,
      required: false
    },
    isCustomLinkTo: {
      type: Boolean,
      default: true
    },
    hasOrsUrl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      this1: this
    }
  },
  computed: {
    internalLinks() {
      let pageList = this.$store.state.states.pageList
      let linkArr = []
      pageList.forEach(page => {
        linkArr.push({
          name: page.name,
          value: page.publicId,
          url: page.url
        })
      })
      return linkArr
    },
    subLinks() {
      const pageName =
        this.$store.state.states.pageList.find(page => page.publicId === this.$store.state.states.getDataPageIds.pageId)
          ?.name || ""
      const subPageList = this.$store.state[this.request_prefix].page.children
      const linkArr = []
      subPageList.forEach((page, index) => {
        linkArr.push({
          name: `${pageName}-第${index + 1}页`,
          value: page.container_id
        })
      })
      return linkArr
    },
    openBlankPageVal: {
      get() {
        if (typeof this.openBlankPage === "string") {
          return this.openBlankPage === "新页面" ? true : false
        }
        return this.openBlankPage
      },
      set(newVal) {
        this.$emit("update:openBlankPage", newVal)
      }
    },
    accessRulersVal: {
      get() {
        return this.accessRulers
      },
      set(newVal) {
        this.$emit("update:accessRulers", newVal)
      }
    },
    internalLinkNameVal: {
      get() {
        return this.internalLinkName
      },
      set(newVal) {
        this.$emit("update:internalLinkName", newVal)
      }
    },
    subLinkNameVal: {
      get() {
        return this.subLinkName
      },
      set(newVal) {
        this.$emit("update:subLinkName", newVal)
      }
    },
    linkAddressVal: {
      get() {
        return this.linkAddress
      },
      set(newVal) {
        if (newVal === "自定义") {
          !this.isYzDataCenter && (this.linkUrlVal = "")
        } else if (newVal === "内部链接" || newVal === "下级链接") {
          !this.isYzDataCenter && (this.linkUrlVal = "")
          this.internalLinkNameVal = ""
          this.subLinkNameVal = ""
        }
        this.$emit("update:linkAddress", newVal)
      }
    },
    linkUrlVal: {
      get() {
        return this.linkUrl
      },
      set(newVal) {
        this.$emit("update:linkUrl", newVal)
      }
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    dataOptions() {
      const options = []
      if(this.businessType === "more") {
        options.push({ value: "默认", title: "默认" })
      }
      options.push({ value: "自定义", title: "链接地址" })
      options.push({ value: "内部链接", title: this.isPhoneFullScreen ? "平级页面" : "页面" })
      if(this.isPhoneFullScreen) {
        options.push({ value: "下级链接", title: "下级页面" })
      }
      if(this.hasOrsUrl) {
        options.push({ value: "数据源", title: "数据源" })
      }
      return options
    }
  },
  methods: {
    selectPage(item) {
      let url = `/v2/p/${item.value}`
      this.internalLinkNameVal = item.name
      this.linkUrlVal = url
    },
    selectSubPage(item) {
      this.subLinkNameVal = item.name
      this.linkUrlVal = `${item.value}`
    },
    clickRadioGroup(e) {
      // 选中了单选框后，重复点击支持反选
      if (e.target.type === "radio" && e.target.value === this.linkAddressVal) {
        this.linkAddressVal = ""
      }
    }
  }
}
</script>

<style scoped lang="scss">
.boxshadow-conatiner {
  position: relative;
}
.boxshadow-wrap {
  position: absolute;
  padding: 18px;
  width: 252px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  z-index: 10;
}
.w100_40 {
  width: calc(100% - 36px);
}
.color-picker-container:hover .bind-icon {
  display: inline-block;
}
.color-picker-container .bind-icon {
  display: none;
  position: absolute;
  right: 6px;
  top: 4px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  text-align: center;
  font-size: 24px;
  cursor: pointer;
  overflow: hidden;
}
.color-picker-container .bind-icon:visited,
.color-picker-container .bind-icon:active {
  background-color: transparent;
}
.color-picker-container .color-text {
  width: calc(100% - 40px);
}
::v-deep .el-color-picker__mask {
  width: 20px;
  height: 20px;
  background-color: transparent;
}
::v-deep .el-color-picker.is-disabled .el-color-picker__color {
  border-radius: 50%;
  overflow: hidden;
}
.boxshadow-list {
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 8px;
  position: relative;
  > li:not(:last-child) {
    margin-bottom: 8px;
  }
  > li {
    background: var(--inputBg);
    position: relative;
    height: 32px;
    border-radius: 4px;
    padding: 6px;
    &:hover {
      .right-handle-icon {
        display: inline-block;
      }
    }
    &.active {
      border-color: var(--themeColor);
    }
  }
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
  }
  .delete-boxshadow {
    font-size: 14px;
  }
}
.mr16 {
  margin-right: 16px;
}
::v-deep .el-radio:last-child {
  margin-right: 0 !important;
}
</style>
